export default __webpack_public_path__ + "static/media/elevate-blk-poster-1.a0495b66.jpg";